module.exports = __webpack_public_path__ + "static/4-6623e8b60e032c919abc24fd9b0ecab5.jpg";